import { createCustomEvent, updateParamFor } from "../../../../javascript/shared/helpers";
import digestChannel from "../../../../javascript/channels/my_via/digest_channel";

export default class extends Controller {
  static targets = ["primaryContent"]

  connect() {
    this.shiftContentWithResponse = this.shiftContentWithResponse.bind(this)
    this.replaceContentWithResponse = this.replaceContentWithResponse.bind(this)
    this.goToState = this.goToState.bind(this)
    this.fadeList = this.fadeList.bind(this)
    this.replaceElementWith = this.replaceElementWith.bind(this)

    // State init
    this.states = {}
    App.Helpers.listenToCustomEvent(document, "day-shift:fetch-success", this.shiftContentWithResponse)
    App.Helpers.listenToCustomEvent(document, "digest-view:fetch-success", this.replaceContentWithResponse)
    window.addEventListener("popstate", this.goToState)

    // Channel Init
    App.Helpers.listenToCustomEvent(document, "my-via:digest-channel-disconnect", this.fadeList)
    App.Helpers.listenToCustomEvent(document, "my-via:reload-digest-content:success", this.replaceElementWith)
    digestChannel.init({ date: this.date, userID: this.userID })
  }

  shiftContentWithResponse({ detail }) {
    const { response: { html, date }, direction } = detail
    this.pushViewState(this.shiftedContentFor(html, direction), date)
  }

  replaceContentWithResponse({ detail }) {
    const { html, date } = detail.response;
    this.pushViewState(html, date)
  }

  goToState(event) {
    const date = (event.state || {}).date
    if (date) {
      this.currentState = date
      document.dispatchEvent(createCustomEvent("day-shift:update-date", this.element, { date }))
    } else {
      window.location = event.currentTarget.location.href
    }
  }

  fadeList(event) {
    this.isRelevantActivity(event) && (this.faded = true)
  }

  replaceElementWith(event) {
    const { html } = event.detail
    this.isRelevantActivity(event) && App.Helpers.replaceElement(this.element, html)
  }

  isRelevantActivity(event) {
    const { userID, date } = event.detail
    return userID == this.userID && date == this.date
  }

  shiftedContentFor(html, direction) {
    return direction === "back" ? this.backShiftedContentFor(html) : this.forwardShiftedContentFor(html)
  }

  backShiftedContentFor(html) {
    App.Helpers.prependContent(this.primaryContentTarget, html)
    this.removeDay("last")
    return this.primaryContentTarget.innerHTML
  }

  forwardShiftedContentFor(html) {
    App.Helpers.appendContent(this.primaryContentTarget, html)
    this.removeDay("first")
    return this.primaryContentTarget.innerHTML
  }

  removeDay(day) {
    this[`${day}Day`].forEach(row => row.remove())
  }

  pushViewState(html, date) {
    this.states[date] = html
    this.currentState = date
    App.Helpers.pushState({ date: this.currentState }, null, updateParamFor(window.location.href, "date", date))
  }

  get currentState() {
    return this.date
  }

  set currentState(date) {
    this.primaryContentTarget.innerHTML = this.states[date]
    this.data.set("date", date)
  }

  get userID() {
    return this.data.get("user-id")
  }

  get date() {
    return this.data.get("date")
  }

  get firstDay() {
    return [this.dayHeaders[0], this.dayContentBodies[0]]
  }

  get lastDay() {
    return [this.dayHeaders.slice(-1)[0], this.dayContentBodies.slice(-1)[0]]
  }

  get dayHeaders() {
    return [...this.primaryContentTarget.querySelectorAll(".my-via--digest-day--component")]
  }

  get dayContentBodies() {
    return [...this.primaryContentTarget.querySelectorAll(".my-via--day-activities--component")]
  }

  set faded(val) {
    this.element.style.opacity = val ? "0.5" : "1"
  }
}



// WEBPACK FOOTER //
// ./app/components/my_via/assets/javascript/my-via-digest-container-card-controller.js